var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#111111;stroke-miterlimit:10;stroke-width:26px;}.cls-2{fill:#111111;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "add-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add_Icon",
    "data-name": "Add Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 150,
    cy: 150,
    r: 132
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M165.76457,228.822H134.23543V165.76457H71.178V133.851h63.05745V71.178h31.52914v62.673H228.822v31.91359H165.76457Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.1da8d22691d2ed87bbcdd4c79a571e71.svg";
export { ForwardRef as ReactComponent };